import { Theme } from '@mui/material/styles';

export default function List(theme: Theme) {
  return {
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto !important',
          marginRight: theme.spacing(1),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto !important',
          marginRight: theme.spacing(1),
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          fontWeight: theme.typography.fontWeightSemiBold,
        },
      },
    },
    MuiListItemText: {
      defaultProps: {
        primaryTypographyProps: {
          typography: 'body3',
        },
        secondaryTypographyProps: {
          component: 'span',
        },
      },

      styleOverrides: {
        root: {
          margin: 0,
        },
        multiline: {
          margin: 0,
        },
      },
    },
  };
}
